import OperationsPageShell from '../components/OperationsPageShell';

const demandData = [
  { district: 'Kivukoni', orders: 420, weight: '8.4t', trend: '+12%' },
  { district: 'Mbezi', orders: 360, weight: '7.1t', trend: '+9%' },
  { district: 'Tegeta', orders: 290, weight: '5.8t', trend: '+6%' },
];

const DistrictDemand = () => (
  <OperationsPageShell
    title="District Demand"
    subtitle="District order volume, current weight, and movement trend over the selected window."
    action={
      <div className="btn-group btn-group-sm" role="group">
        {['3d', '7d', '30d'].map((window) => (
          <button key={window} type="button" className={`uw-btn btn ${window === '7d' ? 'btn-primary' : 'btn-light'}`}>
            {window}
          </button>
        ))}
      </div>
    }
  >
    <div className="row g-5">
      {demandData.map((item) => (
        <div key={item.district} className="col-md-4">
          <div className="card border h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">{item.district}</h5>
                <span className="badge badge-light-success">{item.trend}</span>
              </div>
              <div className="mb-2">
                <small className="text-muted">Orders</small>
                <div className="fs-3 fw-bold">{item.orders}</div>
              </div>
              <div>
                <small className="text-muted">Total weight</small>
                <div className="fs-5 fw-semibold">{item.weight}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </OperationsPageShell>
);

export default DistrictDemand;
